import Head from "next/head";
import Link from "next/link";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { appActions } from "../../store/app";
import { LEGAL } from "../../lib/legal";
import styles from "./legal.module.css";

export const LEGAL_PAGES = [["/terms", "Terms of Service"], ["/privacy", "Privacy Policy"], ["/copyright", "Copyright & DMCA"], ["/guidelines", "Community Guidelines"]];

// A policy page: title, last-updated date, contents, and numbered sections ([id, heading, body]).
export default function LegalPage({ title, description, intro, sections, children }) {
  const dispatch = useDispatch();
  useEffect(() => { dispatch(appActions.setPageLoaded()); }, [dispatch]);
  return <main className={styles.page}>
    <Head><title>{`${title} | TrueChops`}</title><meta name="description" content={description} /></Head>
    <nav className={styles.related} aria-label="Policies">{LEGAL_PAGES.map(([href, label]) => <Link key={href} href={href}>{label}</Link>)}</nav>
    <article className={styles.article}>
      <h1>{title}</h1>
      <p className={styles.updated}>Last updated {LEGAL.updated}</p>
      {intro && <div className={styles.intro}>{intro}</div>}
      {sections?.length > 0 && <nav className={styles.contents} aria-label="Contents"><ol>{sections.map(([id, heading]) => <li key={id}><a href={`#${id}`}>{heading}</a></li>)}</ol></nav>}
      {sections?.map(([id, heading, body], index) => <section key={id} id={id} aria-labelledby={`${id}-heading`}>
        <h2 id={`${id}-heading`}>{index + 1}. {heading}</h2>{body}
      </section>)}
      {children}
    </article>
  </main>;
}

// How to reach the designated copyright agent.
export function AgentContact() {
  const { agent } = LEGAL;
  return <address className={styles.contact}>
    <strong>{agent.name}</strong><br />
    Email: <a href={`mailto:${agent.email}`}>{agent.email}</a>
    {agent.address && <><br />Mail: {agent.address}</>}
    {agent.phone && <><br />Phone: {agent.phone}</>}
  </address>;
}
